module.exports = __webpack_public_path__ + "img/shujujiashicang.55636847.png";